module.exports = __webpack_public_path__ + "img/home-3.600240b3.png";